import React, { useState } from "react";
function DynamicSelectOption({optionList}){
    const [val,setVal]=useState('')
    const data=optionList;
    return(
        <div>
            <select value={val} onChange={e=>setVal(e.target.value)}>
                {
                    data.map(opt=><option>{opt}</option>)
                }
            </select>
        
        </div>
    );
}
export default DynamicSelectOption;